import type { GitBranchScope } from './resolve-git-branch-scope.js';
import type { FileBrowserReadResult } from './file-browser-result-types.js';
import type { FileBrowserRequestMessage } from './types.js';
import { beginFileBrowserRead, endFileBrowserRead } from './in-flight.js';
import { readFileAsync } from '../read/index.js';
import { readGitTreeFileAsync } from '../../git/tree/index.js';

export async function executeFileBrowserRead(params: {
  msg: Pick<
    FileBrowserRequestMessage,
    'startLine' | 'endLine' | 'lineOffset' | 'lineChunkSize' | 'encoding'
  >;
  reqPath: string;
  sessionParentPath?: string;
  gitScope: GitBranchScope | null;
}): Promise<FileBrowserReadResult | { error: string }> {
  const { msg, reqPath, sessionParentPath, gitScope } = params;
  const startLine = typeof msg.startLine === 'number' ? msg.startLine : undefined;
  const endLine = typeof msg.endLine === 'number' ? msg.endLine : undefined;
  const lineOffset = typeof msg.lineOffset === 'number' ? msg.lineOffset : undefined;
  const lineChunkSize = typeof msg.lineChunkSize === 'number' ? msg.lineChunkSize : undefined;
  const encoding = msg.encoding === 'base64' ? 'base64' : 'utf8';

  if (gitScope) {
    return readGitTreeFileAsync(
      gitScope.repoAbsPath,
      gitScope.branch,
      reqPath,
      startLine,
      endLine,
      lineOffset,
      lineChunkSize,
      encoding,
    );
  }

  beginFileBrowserRead();
  try {
    return await readFileAsync(
      reqPath,
      startLine,
      endLine,
      lineOffset,
      lineChunkSize,
      sessionParentPath,
      encoding,
      { skipInitialYield: true, useResolvedSize: true },
    );
  } finally {
    endFileBrowserRead();
  }
}
